import { SIDEBAR_VIEWS, MAP_LAYER_IDS, MAP_TOOLS } from '../../../lib/constants';
import ghAnalytics from '../../../lib/analytics';
import AlertCircle from '../../../assets/svg/Feather/AlertCircle';
import Check from '../../../assets/svg/Feather/Check';

export default (dispatch) => ({
  showCalculatingToast: () => {
    dispatch({
      type: 'toast/show',
      payload: {
        text: 'Calculating Point Elevations...',
        loader: true
      }
    });
  },

  beginCreatingPoint: () => {
    dispatch({
      type: 'app/setShowSidebar',
      payload: false,
    });
    ghAnalytics.logWaypointStarted();
    dispatch({
      type: 'map/resetWidgetState',
    });
    dispatch({
      type: 'map/enableSketchPointTool'
    });
    dispatch({
      type: 'map/setActiveTool',
      payload: MAP_TOOLS.Sketch_Point,
    });
  },

  beginCreatingPolyline: () => {
    dispatch({
      type: 'app/setShowSidebar',
      payload: false,
    });
    ghAnalytics.logLineStarted();

    dispatch({
      type: 'map/resetWidgetState',
    });
    dispatch({
      type: 'map/enableSketchPolylineTool'
    });
    dispatch({
      type: 'map/setActiveTool',
      payload: MAP_TOOLS.Sketch_Polyline,
    });
  },

  beginCreatingPolygon: () => {
    dispatch({
      type: 'app/setShowSidebar',
      payload: false,
    });
    ghAnalytics.logAreaStarted();
    dispatch({
      type: 'map/resetWidgetState',
    });
    dispatch({
      type: 'map/enableSketchPolygonTool'
    });
    dispatch({
      type: 'map/setActiveTool',
      payload: MAP_TOOLS.Sketch_Polygon,
    });
  },

  setSketchWidgetRef: (ref) => {
    dispatch({
      type: 'map/setSketchWidgetRef',
      payload: ref
    });
  },

  createFeature: (feature) => {
    const { uuid: featureTempId, properties: { ghType: featureType } } = feature
    dispatch({
      type: 'map/resetWidgetState',
    });

    dispatch({
      type: 'features/initNewFeature',
      payload: feature,
    });

    dispatch({
      type: 'toast/show',
      payload: {
        text: `Saving ${feature.ghType}...`,
        loader: true
      }
    });

    dispatch({
      type: 'map/renderFeatureGraphic',
      payload: {
        feature: feature,
        layerId: MAP_LAYER_IDS.content
      }
    });
     dispatch({
      type: 'features/saveFeatureEffect',
      callback: (featureId, error) => {
        if (featureId) {
          dispatch({
            type: 'features/getFeature',
            payload: featureId,
            callback: (feature) => {
              feature = { isVisible: true, ...feature }
              dispatch({
                type: 'features/addNewFeatureToUserData',
                payload: feature,
              });
  
              ghAnalytics.logCreateFeature(feature);

              dispatch({
                type: 'map/updateFeatureGraphicAttributes',
                payload: {
                  featureId: featureTempId,
                  layerId: MAP_LAYER_IDS.content,
                  attributes: feature
                }
              });

              dispatch({
                type: 'toast/show',
                payload: {
                  text: `${featureType} Saved`,
                  icon: Check,
                  iconColor: '#F37735'
                }
              });
              setTimeout(() => {
                dispatch({
                  type: 'toast/dismiss'
                });
              }, 3500);

              dispatch({
                type: 'features/setFeatureError',
                payload: {
                  featureErrorId: '',
                  hasFeatureErrored: false
                }
              });

              // once the waypoint is saved, set it as selectedFeature, and then remove it from newWaypoint.
              dispatch({
                type: 'features/setSelectedFeature',
                payload: feature
              });
              dispatch({
                type: 'features/cancelNewFeature'
              });
              dispatch({
                type: 'features/setPreviousFeatureState',
                payload: feature
              });
              dispatch({
                type: 'app/setShowSidebar',
                payload: true,
              });
              dispatch({
                type: 'app/gotoSidebarWithHistory',
                payload: SIDEBAR_VIEWS.FeatureDetail,
              });
              dispatch({
                type: 'features/setFeaturesVisibility',
                payload: { featureId: feature.uuid, visibility: true, type: 'feature' }
              })
            }
          });
        } else {
          dispatch({
            type: 'toast/show',
            payload: {
              text: 'There was an issue and your ' + featureType + ' was not saved.',
              icon: AlertCircle,
              iconColor: '#FF3B30',
              dismissable: true
            }
          });
          dispatch({
            type: 'map/removeGraphicByFeatureId',
            payload: {
              featureId: featureTempId,
              layerId: MAP_LAYER_IDS.content
            }
          });
          dispatch({
            type: 'app/setShowSidebar',
            payload: true,
          });
          dispatch({
            type: 'features/setFeatureError',
            payload: {
              featureErrorId: featureId,
              hasFeatureErrored: true
            }
          });
        }
      }
    });
  },

  cancelWidget: () => {
    dispatch({
      type: 'app/setShowSidebar',
      payload: true,
    });
    dispatch({
      type: 'map/resetWidgetState'
    });
  },
});